// extracted by mini-css-extract-plugin
export default {"noAccess":"UserCard-module__noAccess--eHrlj","footer":"UserCard-module__footer--GYd8F","animatedBackground":"UserCard-module__animatedBackground--RF5uU"};